/**
 * @type {{
 *   benefits: string;
 *   currentInformation: string;
 *   applyTextBefore: string;
 *   applyTextAfter: string;
 *   recommendation: string;
 *   searchRecommendation: string;
 *   information: string;
 *   trust: string;
 *   headerImage: string;
 *   loginFormBefore: string;
 *   loginFormAfter: string;
 *   slot1: string;
 *   slot2: string;
 *   slot3: string;
 *   slot4: string;
 *   slot5: string; }}
 */
const SLOTS_MAP = {
  benefits: 'JOB_POSTING_BENEFITS',
  currentInformation: 'JOB_POSTING_CURRENT_INFORMATION',
  applyTextBefore: 'JOB_POSTING_APPLY_TEXT_BEFORE',
  applyTextAfter: 'JOB_POSTING_APPLY_TEXT_AFTER',
  recommendation: 'JOB_POSTING_RECOMMENDATION',
  searchRecommendation: 'CONTENT_SEARCH_RESULT_RECOMMENDATION',
  information: 'JOB_POSTING_APPLICATION_INFORMATION',
  trust: 'JOB_POSTING_TRUST',
  headerImage: 'JOB_POSTING_HEADER_IMAGE',
  loginFormBefore: 'LOGIN_PAGE_FORM_BEFORE',
  loginFormAfter: 'LOGIN_PAGE_FORM_AFTER',
  slot1: 'JOB_POSTING_SLOT_1',
  slot2: 'JOB_POSTING_SLOT_2',
  slot3: 'JOB_POSTING_SLOT_3',
  slot4: 'JOB_POSTING_SLOT_4',
  slot5: 'JOB_POSTING_SLOT_5',
};

export default SLOTS_MAP;
